let IS_MOBILE_MENU_OPEN = false;
let lastScrollY = window.scrollY;

function updateHeights() {
  const topBanner = document.querySelector(".top-banner-section");
  const stickyHeader = document.querySelector(".sticky-header");
  const quickAccess = document.querySelector("#quick-access");

  if (topBanner && stickyHeader && quickAccess) {
    const topBannerHeight = topBanner.offsetHeight || 0;
    const stickyHeaderHeight = stickyHeader.offsetHeight || 0;
    const totalHeight = topBannerHeight + stickyHeaderHeight;

    document.documentElement.style.setProperty(
      "--quick-access-top",
      totalHeight + "px",
    );
    const remainingHeight = window.innerHeight - totalHeight;
    document.documentElement.style.setProperty(
      "--remaining-height",
      remainingHeight + "px",
    );
  }
}

function toggleMobileMainMenu() {
  const menuTrigger = document.querySelector("#menutrigger");
  const mobileMenuTree = document.querySelector("#mobile-menu-tree");
  const quickAccess = document.querySelector("#quick-access");
  const menuWrapper = document.querySelector(".menu-wrapper");
  const parentCategories = document.querySelectorAll(".parent-category");
  const body = document.body;

  if (IS_MOBILE_MENU_OPEN) {
    body.classList.remove("hide-chat-btn", "overflow-hidden");
    menuTrigger.classList.remove("close");
    mobileMenuTree.classList.remove("hide-panel");
    quickAccess.classList.remove("open");
    menuWrapper.style.display = "none";
    parentCategories.forEach((cat) => cat.classList.remove("active"));
  } else {
    updateHeights();
    body.classList.add("hide-chat-btn", "overflow-hidden");
    menuTrigger.classList.add("close");
    quickAccess.classList.add("open");
    menuWrapper.style.display = "block";
  }

  IS_MOBILE_MENU_OPEN = !IS_MOBILE_MENU_OPEN;
}

window.addEventListener("scroll", () => {
  document.querySelector(".hidden-xs.nav")?.classList.remove("hover");
});

document.querySelectorAll(".mobile-menu-subtitle").forEach((subtitle) => {
  subtitle.addEventListener("click", (event) => {
    if (subtitle.parentElement.querySelector(".mobile-menu-subitems-list")) {
      event.preventDefault();
    }
  });
});

document.querySelector("#menutrigger")?.addEventListener("click", (event) => {
  event.preventDefault();
  toggleMobileMainMenu();
});

document.querySelector(".menu-wrapper")?.addEventListener("click", () => {
  toggleMobileMainMenu();
  document.querySelector("#quick-access")?.classList.remove("prevent-scroll");
});

document.querySelectorAll(".parent-cat").forEach((parentCat) => {
  parentCat.addEventListener("click", () => {
    const nextElement = parentCat.nextElementSibling;
    if (nextElement) {
      nextElement.classList.add("active");
      const subLevels = nextElement.querySelectorAll(".mobile-menu-sublevel");
      if (subLevels.length > 0) {
        subLevels[0].querySelector(".mobile-menu-subtitle")?.click();
      }
    }
    document.querySelector("#mobile-menu-tree")?.classList.add("hide-panel");
    document.querySelector("#quick-access")?.classList.add("prevent-scroll");
  });
});

["click", "keydown"].forEach((eventType) => {
  document.querySelectorAll(".back-to-parent").forEach((backBtn) => {
    backBtn.addEventListener(eventType, (event) => {
      document
        .querySelector("#mobile-menu-tree")
        ?.classList.remove("hide-panel");
      document
        .querySelector("#quick-access")
        ?.classList.remove("prevent-scroll");
      document
        .querySelectorAll(".parent-category")
        .forEach((cat) => cat.classList.remove("active"));
    });
  });
});

document
  .querySelectorAll(".level-top.hasSublinks, .submenu-container")
  .forEach((element) => {
    element.addEventListener("mouseenter", () => {
      document.querySelector(".hidden-xs.nav")?.classList.add("hover");
    });
    element.addEventListener("mouseleave", () => {
      document.querySelector(".hidden-xs.nav")?.classList.remove("hover");
    });
  });

document.querySelectorAll(".desktop-menu > li > a").forEach((link) => {
  link.addEventListener("click", (event) => {
    if (link.getAttribute("href") === "#") {
      event.preventDefault();
    }
  });
});

// Keyboard accessible site navigation

const menuItems = document.querySelectorAll("ul.desktop-menu > li.level-top");

menuItems.forEach((item, index) => {
  const submenu = item.querySelector(".submenu-container");
  const menuColumns = submenu?.querySelectorAll(".submenu-columns");

  if (!menuColumns) return;

  const menuLinks = Array.from(menuColumns).reduce((links, column) => {
    const menuItems = column.querySelectorAll("ul.level0 > li.level1 > a");
    return links.concat(Array.from(menuItems));
  }, []);

  function openSubmenu() {
    document.querySelectorAll(".submenu-container").forEach((sub) => {
      sub.classList.remove("open");
    });
    submenu.classList.add("open");
    menuLinks[0].focus(); // set initial focus to first menu item
    item.addEventListener("keydown", handleKeydown);
  }

  function closeSubmenu() {
    submenu.classList.remove("open");
    item.removeEventListener("keydown", handleKeydown);
  }

  function handleKeydown(event) {
    if (event.keyCode === 13) {
      // Enter key
      if (submenu.classList.contains("open")) {
        closeSubmenu();
      } else {
        openSubmenu();
      }
      event.preventDefault();
    }
    if (event.keyCode === 9 && submenu.classList.contains("open")) {
      // Tab key and submenu is open
      if (event.shiftKey) {
        // Shift + Tab
        if (index > 0) {
          menuItems[index - 1].querySelector("a").focus();
        } else {
          menuItems[menuItems.length - 1].querySelector("a").focus();
        }
      } else {
        // Tab
        if (index < menuItems.length - 1) {
          menuItems[index + 1].querySelector("a").focus();
        } else {
          menuItems[0].querySelector("a").focus();
        }
      }
    }
    if (event.keyCode === 38 || event.keyCode === 40) {
      // Up arrow or Down arrow
      event.preventDefault();
      let currentIndex = menuLinks.findIndex(
        (link) => link === document.activeElement,
      );
      let nextIndex =
        event.keyCode === 38
          ? currentIndex - 1 < 0
            ? menuLinks.length - 1
            : currentIndex - 1
          : currentIndex + 1 >= menuLinks.length
            ? 0
            : currentIndex + 1;
      menuLinks[nextIndex].focus();
    }
  }

  item.addEventListener("keydown", (event) => {
    // Enter key
    if (event.keyCode === 13) {
      submenu.classList.contains("open") ? closeSubmenu() : openSubmenu();
      // Esc key handle
    } else if (event.keyCode === 27) {
      closeSubmenu();
    }
  });
});

// Sticky site navigation
function updateHeaderHeights() {
  const topBanner = document.querySelector(".top-banner-section");
  const header = document.querySelector(".sticky-header");

  if (!header) return;

  const headerHeightTopBanner = topBanner?.offsetHeight || 0;
  const headerHeight = header.offsetHeight;

  const scrollY = window.scrollY;

  document.documentElement.style.setProperty(
    "--header-position",
    `${headerHeight}px`,
  );

  if (scrollY >= headerHeightTopBanner) {
    document.documentElement.style.setProperty(
      "--header-position-all",
      `${headerHeight}px`,
    );
  } else {
    document.documentElement.style.setProperty(
      "--header-position-all",
      `${headerHeightTopBanner + headerHeight}px`,
    );
  }
}


updateHeaderHeights();

window.addEventListener("resize", updateHeaderHeights);

window.addEventListener("scroll", () => {
  const header = document.querySelector(".sticky-header");

  const currentScrollY = window.scrollY;
  const headerHeight = header.offsetHeight;

  if (currentScrollY > lastScrollY) {
    header.classList.add("hide-sticky");
    document.documentElement.style.setProperty("--header-position", "0px");
  } else {
    header.classList.remove("hide-sticky");
    document.documentElement.style.setProperty(
      "--header-position",
      `${headerHeight}px`,
    );
  }

  lastScrollY = currentScrollY;
});

setTimeout(() => {
  const stickyHeader = document.querySelector(".sticky-header");
  const headerHeight = stickyHeader.offsetHeight;
  document.documentElement.style.setProperty(
    "--vh-header",
    `${headerHeight}px`,
  );
}, 2000);

//search js

// Search button click handler
document
  .querySelector(".search-toggle")
  .addEventListener("click", function (e) {
    if (document.documentElement.clientWidth >= 681) {
      updateHeaderHeights();
      
      setTimeout(() => {
        var windowHeight = window.innerHeight;
        var headerHeight = document.querySelector("header").offsetHeight;
        var minHeight =
          document.querySelector(".miniform.desktop").offsetHeight;

        var aaPanelMaxHeight = windowHeight - headerHeight - minHeight + 10;

        document.documentElement.style.setProperty(
          "--aa-panel-max-height",
          aaPanelMaxHeight + "px",
        );
      }, 100);

      document.querySelector(".menu-wrapper").style.display = "none";
      document.body.classList.toggle("blocked");
      document.querySelector(".miniform").classList.toggle("hidden");
      document
        .querySelector(".search-button-wrapper")
        .classList.toggle("arrow-visible");

      document.querySelector(".aa-InputWrapper input").focus();

      document.querySelector(".sticky-header").classList.add("open-search");
    } else {
      document.querySelector("header .aa-DetachedSearchButton").click();
    }
  });

// Closing the search form when clicked
document
  .querySelector(".close-search-form")
  .addEventListener("click", function (event) {
    document.body.classList.remove("blocked");
    document.querySelector(".miniform").classList.add("hidden");
    document
      .querySelector(".search-button-wrapper")
      .classList.remove("arrow-visible");

    document.querySelector(".sticky-header").classList.remove("open-search");
  });

// Close the search form when clicking outside the area
document.addEventListener("click", function (event) {
  var target = event.target;
  var isSearchToggle =
    target.classList.contains("search-toggle") ||
    target.closest(".search-toggle");
  var isInsideMiniform = target.closest(".miniform");
  var isInsidePanel = target.closest(".aa-Panel");

  if (!isInsideMiniform && !isSearchToggle && !isInsidePanel) {
    document.body.classList.remove("blocked");
    document.querySelector(".miniform").classList.add("hidden");
    document
      .querySelector(".search-button-wrapper")
      .classList.remove("arrow-visible");

    document.querySelector(".sticky-header").classList.remove("open-search");
  }
});
